export const ADMIN_COMPANIES = 'admin_companies'
